import { Grid, Title as TitleBase, SubTitle as SubTitleBase, Paragraph } from '@bidalihq/ui';
import tw from 'tailwind-styled-components';

import Section from '@/components/section';
import NotFullColumn from '@/components/not-full-column';

const Title = tw(TitleBase)`
  text-brand-accent
  font-inter
  mt-4
`;

const SubTitle = tw(SubTitleBase)`
  mt-8
  mb-4
`;

const Story = () => {
  return (
    <Section>
      <Grid columns={12}>
        <NotFullColumn>
          <Title>Our Story</Title>
          <SubTitle>Global access to capital.</SubTitle>
          <Paragraph>We believe that everyone should have the right to bank. Sadly this is not the case. We’re creating wonderfully designed products built on top modern technology with the goal of reducing friction and opening up a direct global peer-2-peer marketplace free from costly fees and barriers.</Paragraph>
          <SubTitle>Financial freedom.</SubTitle>
          <Paragraph>Not every country is created equal but their citizens should be. Many countries around the world lack the financial infrastructure and institutional trust that we enjoy in North America and many parts of Europe. We’re bringing modern technology that will allow these countries to leapfrog our legacy financial infrastructure and participate in a more open global economy.</Paragraph>
          <SubTitle>Increased Efficiency. Decreased Fraud.</SubTitle>
          <Paragraph>Credit, debit and gift card fraud is rampant and growing at a rapid pace. It accounts for <strong>billions</strong> of dollars in global loss and is a key piece in the trillion dollar money laundering problem.</Paragraph>
          <Paragraph>Blockchain technology eliminates the ability to make fraudulent transactions by solving the double spending problem in a standard, verifiable, tamper-proof way. This provides the interoperability many merchants need. Bidali provides the tools, APIs and SDKs to leverage this technology to reduce the cost of keeping fraud at bay, thereby increasing efficiency in global markets.</Paragraph>
          <SubTitle>Our Company.</SubTitle>
          <Paragraph>Bidali was spun out of a Canadian venture studio in April, 2018. Traditionally we&apos;ve been a distributed company that employs talented people from all over the world and allows them to work from anywhere.</Paragraph>
          <Paragraph>With this increasingly popular nomadic work style, getting access to funds and paying people is difficult, expensive, or downright impossible in many countries.</Paragraph>
          <Paragraph>We envision a better, safer, more transparent way forward that reduces middlemen and gives more control back to the individual. We’re building the tools to get there.</Paragraph>
        </NotFullColumn>
      </Grid>
    </Section>
  );
};

export default Story;
